import { render, staticRenderFns } from "./NotepadWidget.vue?vue&type=template&id=851b71c8&"
import script from "./NotepadWidget.vue?vue&type=script&lang=js&"
export * from "./NotepadWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports